export const mobile_sound_details = [
	{
		id: 22001,
		no: '2.2.1',
		label: 'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรศัพท์ภายในโครงข่ายของผู้ประกอบการเดียวกัน',
		targeted_text: '1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1: '1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 7,
		priority: 41
	},
	{
		id: 22002,
		no: '2.2.1',
		label: 'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรศัพท์ภายในโครงข่ายของผู้ประกอบการเดียวกัน',
		targeted_text: '2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1: '2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 11,
		priority: 42
	},
	{
		id: 22003,
		no: '2.2.2',
		label: 'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรข้ามโครงข่ายต่างผู้ประกอบการ',
		targeted_text: '1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1: '1. ช่วงเวลา 10.00 - 13.00 น.เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 16,
		priority: 43
	},
	{
		id: 22004,
		no: '2.2.2',
		label: 'อัตราส่วนการเรียกสำเร็จ (Successful call ratio) กรณีที่เป็นการโทรข้ามโครงข่ายต่างผู้ประกอบการ',
		targeted_text: '2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_1: '2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 20,
		priority: 44
	},
	{
		id: 22005,
		no: '2.2.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate)',
		targeted_text: '1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่เกินร้อยละ 2',
		subLabel_1: '1. ช่วงเวลา 10.00 - 13.00 น. เฉลี่ยทุก 3 เดือน ไม่เกินร้อยละ 2',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 25,
		priority: 45
	},
	{
		id: 22006,
		no: '2.2.3',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate)',
		targeted_text: '2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่เกินร้อยละ 2',
		subLabel_1: '2. ช่วงเวลา 16.00 - 19.00 น. เฉลี่ยทุก 3 เดือน ไม่เกินร้อยละ 2',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 29,
		priority: 46
	},
	{
		id: 22007,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: 'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '1-ภาคเหนือ',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I',
			'E'
		],
		excelValueRow: 36,
		priority: 47
	},
	{
		id: 22008,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: '',
		subLabel_1: 'MOS เฉลี่ย ไม่ต่ำกว่า 2.5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2.5,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 37,
		priority: 47.1
	},
	{
		id: 22009,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: 'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '2-ภาคใต้',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I',
			'E'
		],
		excelValueRow: 38,
		priority: 48
	},
	{
		id: 22010,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: '',
		subLabel_1: 'MOS เฉลี่ย ไม่ต่ำกว่า 2.5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2.5,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 39,
		priority: 48.1
	},
	{
		id: 22011,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: 'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '3-ภาคกลาง',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I',
			'E'
		],
		excelValueRow: 40,
		priority: 49
	},
	{
		id: 22012,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: '',
		subLabel_1: 'MOS เฉลี่ย ไม่ต่ำกว่า 2.5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2.5,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 41,
		priority: 49.1
	},
	{
		id: 22013,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: 'ร้อยละ 90 ของข้อมูลที่วัดได้ ต้องไม่ต่ำกว่าค่า 2.5 (MoS Score)',
		subLabel_1: '4-ภาคตะวันออกเฉียงเหนือ',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I',
			'E'
		],
		excelValueRow: 42,
		priority: 50
	},
	{
		id: 22014,
		no: '2.2.4',
		label: 'คุณภาพของเสียง (Mean Opinion Score (MOS))',
		targeted_text: '',
		subLabel_1: 'MOS เฉลี่ย ไม่ต่ำกว่า 2.5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2.5,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 43,
		priority: 50.1
	},
	{
		id: 22015,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่เกินร้อยละ 2',
		subLabel_1: '1-ท่าอากาศยานสุวรรณภูมิ',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 45,
		priority: 51
	},
	{
		id: 22016,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่เกินร้อยละ 2',
		subLabel_1: '2-ท่าอากาศยานดอนเมือง',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 46,
		priority: 52
	},
	{
		id: 22017,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่เกินร้อยละ 2',
		subLabel_1: '3-สถานีขนส่งผู้โดยสารกรุงเทพ (จตุจักร)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 47,
		priority: 53
	},
	{
		id: 22018,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่เกินร้อยละ 2',
		subLabel_1: '4-สถานีขนส่งผู้โดยสารกรุงเทพ (ถนนบรมราชชนนี)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 48,
		priority: 54
	},
	{
		id: 22019,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่เกินร้อยละ 2',
		subLabel_1: '5-สถานีขนส่งผู้โดยสารกรุงเทพ (เอกมัย)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 49,
		priority: 55
	},
	{
		id: 22020,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่เกินร้อยละ 2',
		subLabel_1: '6-สถานีรถไฟกรุงเทพ (หัวลำโพง)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 50,
		priority: 55.1
	},
	{
		id: 22021,
		no: '2.2.5',
		label: 'อัตราส่วนของกรณีที่สายหลุด (Drop Call Rate) ในพื้นที่เฝ้าระวัง',
		targeted_text: 'ไม่เกินร้อยละ 2',
		subLabel_1: '7-สถานีกลางกรุงเทพอภิวัฒน์ (บางซื่อ)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2,
		targetCondition: 'le',
		filling_condition: 'ช่องสีเขียว ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			month_1: null,
			month_2: null,
			month_3: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'F',
			'G',
			'H',
			'I'
		],
		excelValueRow: 51,
		priority: 55.2
	}
]